module.exports = __webpack_public_path__ + "static/img/event14.71dd6b1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/event14.png
// module id = zkr8
// module chunks = 1